import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated() && !authService.isTokenExpired()) {
    return true;
  }

  if (authService.isTokenExpired()) {
    authService.logout();
  }

  router.navigate(['/login'], {
    queryParams: { returnUrl: router.url }
  });

  return false;
};
